import NewProgram from './NewProgram.vue';

export default NewProgram;



// WEBPACK FOOTER //
// ./src/pages/newprogram/index.ts